import { render, staticRenderFns } from "./CapSetting.vue?vue&type=template&id=043f6940"
import script from "./CapSetting.vue?vue&type=script&lang=js"
export * from "./CapSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports